export enum JumpErrorCodes {
  NoError = 0,
  TechnicalError = 1,
  LinkExpired = 2,
  UnableAutoLogin = 3,
  WrongUserLoggedIn = 4,
  OperationNotFound = 5
}
